import { ButtonMantine } from 'ui';

import { useEditPeerPageModalProvider } from './EditPeerPageModalProvider';

const EditPeerPageAction = () => {
  const { openModalById } = useEditPeerPageModalProvider({});
  return (
    <ButtonMantine variant="outline" onClick={() => openModalById('base')}>
      Edit Page
    </ButtonMantine>
  );
};

export { EditPeerPageAction };
